import { Box, Pressable } from '@rbilabs/universal-components';

export const Container = Box.withConfig({
  backgroundColor: Styles.color.cardBackground,
  borderRadius: Styles.borderRadius,
  marginY: '$4',
  paddingX: { base: '$4', md: '$6' },
  paddingY: { base: '$4', md: '$6' },
});

export const DescriptionContainer = Pressable.withConfig({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
});
